console.time("AppReady");
import {
	EventDispatcher,
	DomUtil
} from "cartovista";
import CartovistaExtend from "cartovistaExtend/CartovistaExtend";
import Forage from "cartovistaExtend/mapTools/Forage";
import ToggleYears from "cartovistaExtend/mapTools/ToggleYears";
import Constat from "cartovistaExtend/panels/Constat";
import {loadData, createLayers, initZoomLayeringLayers} from "./ServerDataHandlers";
import { Modal } from 'bootstrap';
import "../styles/popover.css";

class App extends EventDispatcher {
	constructor(cartovista) {
		super();
		this.cartovista = cartovista;
		window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
    }

    _onCartoVistaMapLoaded() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        createLayers();
        initZoomLayeringLayers();
        if (!DomUtil.isResponsiveUI()) {
            window.cartovista.getUIController(this._map).findInstance("Constat_panel").activate();
        }
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        this._loadCustomModules();
    }

    //inclure les modules custom
    _loadCustomModules() {
        new Constat();
        new Forage();
        new ToggleYears();
        console.timeEnd("AppReady");
        $("#preloader").remove();
		new Modal('#IntroModal').show();
    }

    _onThemeSetChanged() {
        if (this._map.activeThemeSet) {
            //log onThemeSetChanged event on piwik
            try {
                dataLayer.push({'event':'onThemeSetChanged', 'activeThemeSet': C.APP_NAME + " - " + this._map.activeThemeSet.id});
            } catch(error) {
                //piwik blocked by an add blocker
                window.ClientErrorsLogger.logPiwikError(error);
            }
        }
    }
}

$().ready(function() {
	new App(new CartovistaExtend());
});
